import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaymentStore } from '../service/payment.store';
import { Observable } from 'rxjs/Observable';
import { Payment } from '../models/payment';

@Injectable()
export class LatestPaymentResolver implements Resolve<any> {

  constructor(
    private translateService: TranslateService,
    private paymentStore: PaymentStore
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Payment> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
    }

    return this.paymentStore.loadLatestPayment(id);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/latest-payment.resolver.ts